import { createFileRoute } from "@tanstack/react-router";

type CustomerOrderHistorySearch = { q?: string | undefined };

export const Route = createFileRoute("/_app/customers/order-history")({
  validateSearch: (search: Record<string, unknown>): CustomerOrderHistorySearch => ({
    q: typeof search.q === "string" && search.q.trim() ? search.q.trim() : undefined,
  }),
});
